import { Button, Form, Header } from '@mairistem/composants';

export type ConfirmationChangementProps = {
  libelle: string;
  onValidate: () => void;
  onCancel: () => void;
};

const ConfirmationChangement = ({ libelle, onValidate, onCancel }: ConfirmationChangementProps) => (
  <Form>
    <Form.Group>
      <Header size="small">
        Des saisies ont été réalisées pour le mode de règlement &quot;
        {libelle}
        &quot;.
        <br />
        Elles seront effacées si vous choisissez un autre mode de règlement.
        <br />
        Souhaitez-vous poursuivre ?
      </Header>
    </Form.Group>
    <Form.Group style={{ justifyContent: 'center', gap: '2em', marginBottom: 0 }}>
      <Button positive onClick={onCancel}>
        Non
      </Button>
      <Button onClick={onValidate}>Oui</Button>
    </Form.Group>
  </Form>
);

export default ConfirmationChangement;
